import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiRadioGroup, SuiRadio } from '@splashthat/sui';

import { getFormNode } from 'common/entities/formNode/selectors';
import { updateFormNodeValue } from '../../../actions/nodeActions';

export const PERMISSION_LABEL = 'Permissions';
const PERMISSION_0_LABEL = 'Anyone can edit this content';
const PERMISSION_1_LABEL = 'Lock this content';

/**
 * The view set the locking of a question, so that others can't change any of its settings.
 */
const LockControl = ({ lock, onChange }) => (
    <SuiRadioGroup
        label={PERMISSION_LABEL}
        value={String(lock)}
        onChange={(event, value) => onChange(parseInt(value, 10))}
    >
        <SuiRadio value="0" label={PERMISSION_0_LABEL} />
        <SuiRadio value="1" label={PERMISSION_1_LABEL} />
    </SuiRadioGroup>
);

LockControl.propTypes = {
    lock: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        lock: props.formNodeId ? formNode.lock : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (lock) => dispatch(updateFormNodeValue(ownProps.formNodeId, 'lock', lock)),
});

const ConnectedLockControl = connect(mapStateToProps, mapDispatchToProps)(LockControl);

ConnectedLockControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedLockControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedLockControl;
